<template>
  <footer class="footer-area bg-white text-center rounded-top-7">
    <p class="fs-14">
      © <span class="text-primary-div">Mero Prints</span> is Proudly Owned by
      <a href="https://www.brosoftltd.com/" target="_blank" class="text-decoration-none text-primary">
        Bro Soft Pvt. Ltd.
      </a>
    </p>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>
